var _g, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "globe",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.6 208.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globe-contents",
    className: "opacity-0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill-green",
    d: "M22.2,103.1c0-49.7,36.9-90.9,84.7-97.6c-0.9,0-1.8,0-2.7,0c-54.4,0-98.6,44.1-98.6,98.6 s44.1,98.6,98.6,98.6c4.7,0,9.3-0.3,13.8-1C64.9,200.2,22.2,156.7,22.2,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dkgreen",
    d: "M120.7,4.6c-4.7,0-9.3,0.3-13.8,1c53.2,1.4,95.8,45,95.8,98.5c0,49.7-36.9,90.9-84.7,97.6c0.9,0,1.8,0,2.7,0 c54.4,0,98.6-44.1,98.6-98.6S175.2,4.6,120.7,4.6z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "stroke-white stroke-5",
    x1: 3.9,
    y1: 104.1,
    x2: 202.1,
    y2: 104.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke-white stroke-5",
    cx: 103.8,
    cy: 104.8,
    rx: 60.6,
    ry: 98.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-white stroke-5",
    x1: 103,
    y1: 4.9,
    x2: 103,
    y2: 203.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flight-path",
    className: "stroke-white stroke-5 stroke-dash",
    d: "M50.9,187.3c-6.2,3.3-30.6,17.6-42.6,4.7C-11.4,170.9,36,111.1,76.4,69.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "plane",
    className: "fill-green opacity-0",
    d: "M84.5,59.8l-26.6-3.7l-2.6,2.2l19.8,9.3 c-2.8,2.3-5.2,4.3-6.4,5.3c-1.3,1-4,3.5-6.3,5.9l-7.9-1.5l-1.6,1.3c0,0,3.1,2,6.1,4.4c-0.3,0.6-0.4,1.1-0.2,1.4s0.7,0.3,1.4,0.1 c1.8,3.4,3.1,6.8,3.1,6.8l1.6-1.3L65,82c2.8-1.8,5.7-4.1,7-5.1c1.2-1,3.6-3,6.4-5.3l5.2,21.3l2.6-2.2l1.6-27 c5.7-4.8,10.9-9.1,9.3-11C95.5,50.8,90.2,55.1,84.5,59.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "globe-outline",
    className: "stroke-white stroke-5 stroke-dash",
    cx: 103,
    cy: 104.1,
    r: 98.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.09f240b74384d8c4eeacce793e2d2898.svg";
export { ForwardRef as ReactComponent };